import useListRowInfStroe from "store/listRowInf";

import { FormEvent } from "react";
import {
  initialFilterStateProps,
  useResvFilterContext,
  useResvListContext,
} from "./context";

// 리스트 조회
export const useSubmit = () => {
  const { filters } = useResvFilterContext();
  const { setParam } = useResvListContext();
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let param = {} as Partial<initialFilterStateProps>;

    filters &&
      (Object.keys(filters) as Array<keyof initialFilterStateProps>).forEach(
        (key) => {
          let value = filters[key];

          if (key === "dateTyp") {
            param = {
              ...param,
              [value + "SDt"]: filters.sDt,
              [value + "Edt"]: filters.eDt,
            };
            return;
          }
          if (key === "sDt" || key === "eDt") {
            return;
          }
          if (!!value) {
            param = {
              ...param,
              [key]: value,
            };
          }
        }
      );
    setParam(param);
  };
  return {
    onSubmit,
  };
};

// 상세모달 오픈
export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;

  const params = {
    no: props.data.rmPdNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };

  setListRowParams(params);
};
